/* eslint-disable no-unused-vars */
import { Form } from 'antd';
import { useEffect, memo } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import InputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import AddSelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import Cascader from '@/containers/cascader_ml/cascader_package_add_ml/Cascader';
import Loading from '@/components/Loading';
import styles from './edit.less?modules';
import { isEmptyObject } from '@/utils/comUtil';

const Edit = (props) => {
  const [form] = Form.useForm();
  const { edit, singleListInfo, handleCancel, formList, loading } = props;

  // 发起请求
  const onFinish = (values) => {
    edit(values, singleListInfo && singleListInfo.id);
  };
  useEffect(() => {
    if (!singleListInfo) {
      return;
    }
    let newData = {};
    !isEmptyObject(formList) &&
      formList.forEach((item) => {
        newData[item.name] = singleListInfo[item.name];
      });
    form.setFieldsValue({
      ...newData,
    });
  }, [form, formList, singleListInfo]);

  const getValue = (e) => {
    e(form.getFieldsValue());
  };

  const resetForm = () => {
    form.resetFields();
  };

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="common-edit-modal"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {!isEmptyObject(formList) &&
            formList.map((item, i) => {
              if (item.type === 'input') {
                return (
                  <InputML
                    labelVal={item.label}
                    placeVal={`请输入${item.label}`}
                    name={item.name}
                    key={item.name + i}
                    required={
                      item.requiredRule
                        ? item.requiredRule
                        : [
                            {
                              required: item.required,
                              whitespace: true,
                              message: `请输入${item.label}`,
                            },
                          ]
                    }
                  />
                );
              }
              if (item.type === 'cascader') {
                return (
                  <Cascader
                    labelVal={item.label}
                    height="47px"
                    labelwidth="130px"
                    onChange={() => {
                      getValue(item.onChange);
                    }}
                    displayRender={item.displayRender}
                    options={item.option}
                    allowClear={item.allowClear}
                    placeVal={`请选择${item.label}`}
                    name={item.name}
                    key={item.name + i}
                  />
                );
              }
              return (
                <AddSelectML
                  required={[
                    {
                      required: true,
                      message: `请选择${item.label}`,
                    },
                  ]}
                  height="47px"
                  labelwidth="130px"
                  labelVal={item.label}
                  // value={item.value}
                  allowClear={item.allowClear}
                  key={item.name + i}
                  placeVal={`请选择${item.label}`}
                  name={item.name}
                  disabled={item.disabled}
                  option={item.option}
                  onChange={item.onChange}
                  className={['sty16']}
                />
              );
            })}
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default memo(Edit);
